


















import { Vue, Component } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { majorNoticeText } from '@/common/constants/index';
import ActivitySwitch from "@/components/common/edit/ActivitySwitch.vue";

@Component({
  components: {
    "activity-switch": ActivitySwitch
  }
})
export default class BarrageSwitch extends Vue {
  @Getter("showBarrage") showBarrage!: boolean;
  @Getter("xmMajordomo") xmMajordomo!: boolean;
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("section") section!: any;
  @Getter("xcxType") xcxType!: string;
  @Action("changeShowBarrage")
  changeShowBarrage!: Function;


  handleSwitchStatus(newStatus: boolean): void {
    if (this.xcxType === "mkb") {
      return;
    }
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: "提示",
        text: majorNoticeText,
        okText: "确定"
      });
      return;
    }
    this.changeShowBarrage(newStatus);
  }
}
